export default {
    notificationTypes: [],
    fcmDevices: [],
};
